import React from 'react';
import './DriftChatButton.scss';
import { onClickEventTracker } from '../../shared/analytics/callAnalytics';
import { EventName, UserInteractionType } from '../../models/GTMEventTypes';
import resolvePath from '../../shared/resolvePath';
import { useParentNodeProvider } from '../../providers/ParentNodeProvider';

export const DriftChatButton = () => {
    const { nodeName: pNodeName, nodeType: pNodeType } =
        useParentNodeProvider();

    return (
        <button
            className="chat-with-us"
            onClick={(e) => {
                if (typeof window[`drift`]?.api?.openChat === `function`) {
                    window[`drift`].api.openChat();
                }
                onClickEventTracker(e, {
                    event: EventName.USER_INTERACTION,
                    event_data: {
                        component_name: `Chat With Us`,
                        component_type: `Drift Button`,
                        parent_name: pNodeName,
                        parent_type: pNodeType,
                        current_path: resolvePath(),
                        next_path: undefined,
                        type: UserInteractionType.BUTTON_CLICK,
                    },
                });
            }}
        >
            Chat With Us
        </button>
    );
};
